// Import all icons
import { 
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  ChevronsUp,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  X,
  Plus,
  Minus,
  Edit,
  Trash2,
  SquarePlus,
  Copy,
  Save,
  RefreshCw,
  Check,
  CheckCircle,
  XCircle,
  AlertCircle,
  Info,
  Lock,
  Unlock,
  Search,
  Filter,
  Download,
  Upload,
  Menu,
  MoreVertical,
  MoreHorizontal,
  Settings,
  Focus,
  Locate,
  Home,
  FileText,
  Folder,
  Calendar,
  Clock,
  User,
  Heart,
  Star,
  Bell
} from 'lucide-vue-next'

// Navigation Icons
export { 
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  ChevronsUp,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown
}

// Action Icons  
export {
  X,
  Plus,
  Minus,
  Edit,
  Trash2,
  SquarePlus,
  Copy,
  Save,
  RefreshCw
}

// Status Icons
export {
  Check,
  CheckCircle,
  XCircle,
  AlertCircle,
  Info,
  Lock,
  Unlock
}

// Utility Icons
export {
  Search,
  Filter,
  Download,
  Upload
}

// Menu & Layout Icons
export {
  Menu,
  MoreVertical,
  MoreHorizontal,
  Settings,
  Focus,
  Locate
}

// Content Icons  
export {
  Home,
  FileText,
  Folder,
  Calendar,
  Clock,
  User,
  Heart,
  Star,
  Bell
}

// Grouped exports for easier consumption
export const icons = {
  // Navigation
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  ChevronsUp,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  
  // Actions
  X,
  Plus,
  Minus,
  Edit,
  Trash2,
  SquarePlus,
  Copy,
  Save,
  RefreshCw,
  
  // Status
  Check,
  CheckCircle,
  XCircle,
  AlertCircle,
  Info,
  Lock,
  Unlock,
  
  // Utility
  Search,
  Filter,
  Download,
  Upload,
  
  // Menu & Layout
  Menu,
  MoreVertical,
  MoreHorizontal,
  Settings,
  Focus,
  Locate,
  
  // Content
  Home,
  FileText,
  Folder,
  Calendar,
  Clock,
  User,
  Heart,
  Star,
  Bell
}